import { render, staticRenderFns } from "./PredmetiReport.vue?vue&type=template&id=e0cc68b2&"
import script from "./PredmetiReport.vue?vue&type=script&lang=js&"
export * from "./PredmetiReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports